<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable placeholder="请选择">
                    <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺名称">
                  <el-select v-model="queryForm.vendorId" filterable clearable placeholder="请选择">
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="任务类型">
                  <el-select v-model="queryForm.taskCode" filterable clearable placeholder="请选择">
                    <el-option v-for="item in taskCodeList" :label="item.taskCodeName" :value="item.taskCode" :key="item.taskCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table :data="tableData">
      <el-table-column label="店铺名称">
        <template slot-scope="scope">
          <el-link type="primary" @click="$router.push({ path: '/buyershop/detail?vendorId=' + scope.row.vendorId })">{{ scope.row.vendorName }}</el-link>
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column prop="taskCode" label="任务类型"></el-table-column>
      <el-table-column prop="data" label="任务明细"></el-table-column>
      <el-table-column prop="status" label="任务状态">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 0">待刷新</template>
          <template v-if="scope.row.status == 1"><span class="success">刷新成功</span></template>
          <template v-if="scope.row.status == 2"><span class="danger">刷新失败</span></template>
        </template>
      </el-table-column>
      <el-table-column prop="costTime" label="任务耗时"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.updateAt) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNum"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

  </div>
</template>

<script>
import {
  getVendorListRF,
  getConfigUpdateList,
  getTaskCodeList,
} from './api';
import utils from '@/utils/util';

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      taskCodeList: [],
      queryForm: {
        vendorAliasId: null,
        vendorId: null,
        taskCode: null,
        pageNum: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    getVendorListRF().then(res => {
      this.vendorList = res.data && res.data.data || [];
    })
    getTaskCodeList().then(res => {
      this.taskCodeList = res.data && res.data.data || [];
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.taskCode = null;
      this.queryForm.pageNum = 1;
      this.getTableData();
    },
    getTableData() {
      getConfigUpdateList({
        ...this.queryForm,
        vendorId: this.queryForm.vendorAliasId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNum) {
      this.queryForm.pageNum = pageNum;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.success {
  color: #67C23A;
}
.danger {
  color: #F56C6C;
}
</style>
